var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui main container"},[_c('Catalog',{attrs:{"store":"orders","header":"Mis pedidos","addButtonLabel":"","columns":_vm.columns,"editOn":"/orders","addOn":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }